import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: 'custom-action' })
export class CustomActionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
